import { render, staticRenderFns } from "./FCREvaluation.vue?vue&type=template&id=20c04d8e&lang=pug"
import script from "./FCREvaluation.vue?vue&type=script&lang=js"
export * from "./FCREvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports